import styles from "./ListActivityCard.module.css"
import React, { useRef } from 'react';
import { useDetailContext } from '../../../context/DetailContext';
import { useTranslation } from "react-i18next";
import { getPrimaryProductImage } from "../../../services/productImageService";
import { usePublicCatalog } from "../../../context/PublicCatalogContext";
import { ActivityCardProps } from "../../../types/activity.types";
import { Users, MapPinned  } from "lucide-react";
import { getPeopleWord } from "../../../utils/people";
import PrimaryButton from "../../Button/PrimaryButton/PrimaryButton";
/**
* List card for activities items
*
* @param props activitiesItemCardProps
* @param {ActivitiesItem} props.product - Product
* @returns TSX.Element
*/
const ListActivityCard = ({ product }: ActivityCardProps) => {
    const { t, i18n } = useTranslation(); // Translation
    const {isPublicView} = usePublicCatalog();
    const { openDetail } = useDetailContext(); // Detail context

    const buttonRef = useRef<HTMLDivElement>(null)

    // Handle opening detail
    const handleOpen = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!buttonRef.current?.contains(e.target as Node)) {
            openDetail && openDetail({id: product.id, type: "activities" }); 
        }
    }

    // Wording for recommended amount of people
    const peopleWord = getPeopleWord(i18n.language, product.guest_count ?? product.guest_count ?? 1)

    
    return(
        <>
            <div className={`${styles.ProductCard} ${styles.ExtraCard}`} key={product.id} onClick={handleOpen}>
                <div className={styles.ProductCardImage} style={{ backgroundImage: `url(${getPrimaryProductImage(product)})` }}></div>
                <div className={styles.ProductCardContent}>
                    <div className={styles.CardContentTop}>
                        <div className={styles.ProductTitle}>
                            <p>{i18n.language === "en" ? product.title_en || "N/A" : product.title}</p>
                        </div>

                    </div>
                    <div className={styles.CardContentBottom}>

                        <div className={styles.ProductSpecs}>
                            <div className={styles.ProductSpec}>
                                <p className={styles.ProductCat}>
                                    {product.category}
                                </p>
                            </div>
                            <div className={styles.ProductSpec}>
                                <div className={styles.SpecIcon}>
                                    <MapPinned/>
                                </div>
                                <div className={styles.SpecText}>
                                    <p>{product.enviroment}</p>
                                </div>
                            </div>
                            <div className={styles.ProductSpec}>
                                <div className={styles.SpecIcon}>
                                    <Users/>
                                </div>
                                <div className={styles.SpecText}>
                                    <p>
                                        {product.guest_count || 1}
                                        {` ${peopleWord}`}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className={styles.CartButtons}>
                            <PrimaryButton text={t("activities.order_activity")} 
                            disabled={isPublicView}
                            onClick={handleOpen} 
                            className={styles.CartButton}
                            />
                        </div>
                    </div>  
                </div>
            </div>
        </>
    )
}
export default ListActivityCard
